import { createRoot } from 'react-dom/client';
import App from './App';
import { startRetiredIntakePurge } from './utils/retired-intake-purge';

void startRetiredIntakePurge();
const root = createRoot(document.getElementById('root')!);
root.render(<App />);
